import React from 'react';

import formatPhone, { parsePhoneNumber } from '@glass/common/modules/utils/formatPhone';
import { PHONE_FIELD_V2 } from '@glass/web/modules/resumes/fieldKeys';

import FormTextField from '@glass/shared/components/Form/FormTextField';

const INPUT_TYPE = 'tel';

const INPUT_PROPS = {
  name: PHONE_FIELD_V2,
  autoComplete: INPUT_TYPE,
  inputMode: INPUT_TYPE,
};

function PhoneField() {
  return (
    <FormTextField
      format={formatPhone}
      inputProps={INPUT_PROPS}
      label="Phone"
      name={PHONE_FIELD_V2}
      parse={parsePhoneNumber}
      pattern="[0-9]*"
      type={INPUT_TYPE}
    />
  );
}
export default PhoneField;
